import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  Paper,
  Divider,
  Stepper,
  StepLabel,
  Step,
  stepConnectorClasses,
  StepConnector,
  Typography,
  Alert,
} from '@mui/material';
import CustomStepIcon from '../form-stepper/CustomStepIcon';
import authService from '../Auth/AuthService';

const info = JSON.parse(localStorage.getItem("device")) || null;
const initialSchoolData = {
  schoolCode: '',
  schoolName: '',
  registrationNumber: '',
  principalName: '',
  contactEmail: '',
  contactPhone: '',
  addressDTO: {
    addressLine1: '',
    addressLine2: '',
    postalCode: '',
    city: '',
    state: '',
    country: '',
    latitude: '',
    longitude: ''
  },
  boardAffiliation: '',
  totalStudents: '',
  totalTeachers: '',
  totalClasses: '',
  establishedYear: '',
  schoolType: '',
  mediumOfInstruction: '',
  logoUrl: '',
  websiteUrl: '',
  createdBy: '',
};
const steps = ['1', '2', '3'];
const form1 = [
  { label: 'School Name', name: 'schoolName', req: true },
  { label: 'Registration Number', name: 'registrationNumber', req: true },
  { label: 'Dise Code/Number', name: 'diseCode', req: true },
  { label: 'Principal Name', name: 'principalName', req: true },
  { label: 'Board Affiliation', name: 'boardAffiliation', req: true },
  { label: 'Established Year', name: 'establishedYear', req: true },
];
const form2 = [
  { label: 'School Type', name: 'schoolType', req: true },
  { label: 'Medium of Instruction', name: 'mediumOfInstruction', req: true },
  { label: 'Total Students', name: 'totalStudents', type: 'number', req: true },
  { label: 'Total Teachers', name: 'totalTeachers', type: 'number', req: true },
  { label: 'Total Classes', name: 'totalClasses', type: 'number', req: true },
  { label: 'Phone', name: 'contactPhone', req: false },
];

const form3 = [
  { label: 'Address Line 1', name: 'addressLine1', req: true },
  { label: 'Address Line 2', name: 'addressLine2', req: false },
  { label: 'Pincode', name: 'pincode', req: true },
  { label: 'City', name: 'city', req: true },
  { label: 'State', name: 'state', req: true },
  { label: 'Country', name: 'country', req: false },
  // { label: 'Latitude', name: 'latitude' },
  // { label: 'Longitude', name: 'longitude' },
  // { label: 'Logo URL', name: 'logoUrl' },
];
const SchoolRegister = () => {
  const [school, setSchool] = useState(initialSchoolData);
  const [pages, setPages] = useState(0);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const userInfo = authService.tokenInfo();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSchool((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeAddress = (e) => {
    const { name, value } = e.target;
    setSchool((prev) => ({
      ...prev,
      addressDTO: {
        ...prev.addressDTO,
        [name]: value
      }
    }));
  };

  const handleSetAddress = () => {

    if (!info) {
      setMessage({
        type: 'error',
        text: "This app requires access to your location. Please enable location permission to proceed."
      })
      return false;
    }
    school.contactEmail = userInfo?.sub;
    school.loginId = userInfo?.log_id;
    school.addressDTO.latitude = info.latitude;
    school.addressDTO.longitude = info.longitude;
    return true;
  };


  const nextPage = () => {
    setPages(pages + 1);
  };
  const prevPage = () => {
    setPages(pages - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFormSection(form2)) return;
    if (!handleSetAddress()) return;
    
    console.log('School Registration Data:', school);
    try {
      const url = authService.pathUrl("POST", "/schools")
      const response = await authService.postAuth(url, school);
      console.log('Success:', response.data);
      window.location.reload();
    } catch (err) {
      console.error('Error:', err);
      setMessage({
        type: 'error',
        text: err.message
      })
    }
  };

  const CustomConnector = (props) => (
    <StepConnector
      {...props}
      sx={{
        [`& .${stepConnectorClasses.line}`]: {
          borderColor: '#ccc',
          borderTopWidth: 3,
        },
        [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
          borderColor: 'green',
        },
        [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
          borderColor: 'green',
        },
      }}
    />
  );

  const validateFormSection = (formFields) => {
    for (let field of formFields) {
      if (field.req) {
        const value = school[field.name];
        if (!value || value.trim() === '') {
          setError(`Please fill out the "${field.label}" field.`);
          return false;
        }
      }
    }
    return true;
  };


  return (
    <Box sx={{ background: '#FFF', p: 1 }}>
      <Paper sx={{ maxWidth: '100%', margin: 0, px: 4, borderRadius: 1 }}>

        <Stepper activeStep={pages} alternativeLabel connector={<CustomConnector />} sx={{ mb: 2 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel slots={{ stepIcon: CustomStepIcon }}>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Divider sx={{ mb: 4 }} />

        <form onSubmit={handleSubmit}>
          {/* section 1 */}
          {pages === 0 ? (<>
            <Grid container spacing={2}>
              {form1.map(({ label, name, type = 'text', req = true }) => (
                <Grid item xs={12} sm={6} mt={2} key={name}>
                  <TextField
                    fullWidth
                    required={req}
                    variant="outlined"
                    label={label}
                    name={name}
                    value={school[name]}
                    onChange={handleChange}
                    type={type}
                  />
                </Grid>
              ))}
              <Typography sx={{ fontSize: '10px', color: 'red' }}>{error}</Typography>
            </Grid>
            <Box display="flex" justifyContent="flex-end" >

              <Button
                onClick={() => { if (validateFormSection(form1)) nextPage(); }}
                variant="contained"
                sx={{
                  mt: 4, width: '40%', py: 1,
                  borderRadius: 6,
                  backgroundColor: '#1b1914',
                  '&:hover': {
                    backgroundColor: '#332a14ff',
                  },
                }}
              >
                Next
              </Button>
            </Box>
          </>
          ) : pages === 1 ? (<>
            {/* //  section 2 */}
            <Grid container spacing={2}>
              {form2.map(({ label, name, type = 'text', req = true }) => (
                <Grid item xs={12} sm={6} mt={2} key={name}>
                  <TextField
                    fullWidth
                    required={req}
                    variant="outlined"
                    label={label}
                    name={name}
                    value={school[name]}
                    onChange={handleChange}
                    type={type}
                  />
                </Grid>
              ))}
            </Grid>
            <Box display="flex" justifyContent="space-between" >
              <Button onClick={() => prevPage()}
                variant="contained"
                sx={{
                  mt: 4, width: '40%', py: 1,
                  borderRadius: 6,
                  backgroundColor: '#1b1914',
                  '&:hover': {
                    backgroundColor: '#332a14ff',
                  },
                }}
              >
                Prev
              </Button>

              <Button onClick={() => nextPage()}
                variant="contained"
                type="submit"
                sx={{
                  mt: 4, width: '40%', py: 1,
                  borderRadius: 6,
                  backgroundColor: '#1b1914',
                  '&:hover': {
                    backgroundColor: '#332a14ff',
                  },
                }}
              >
                Next
              </Button>
            </Box>

          </>
          ) : pages === 2 && (
            // session 3
            <>
              <Grid container spacing={2}>
                {form3.map(({ label, name, type = 'text', req = true }) => (
                  <Grid item xs={12} sm={6} mt={2} key={name}>
                    <TextField
                      fullWidth
                      required={req}
                      variant="outlined"
                      label={label}
                      name={name}
                      value={school.addressDTO[name]}
                      onChange={handleChangeAddress}
                      type={type}
                    />
                  </Grid>
                ))}

              </Grid>
              <Box display="flex" justifyContent="space-between" >
                <Button onClick={() => prevPage()}
                  variant="contained"
                  sx={{
                    mt: 4, width: '40%', py: 1,
                    borderRadius: 6,
                    backgroundColor: '#1b1914',
                    '&:hover': {
                      backgroundColor: '#332a14ff',
                    },
                  }}
                >
                  Prev
                </Button>
                <Button
                  // onClick={() => nextPage()}
                  variant="contained"
                  type="submit"
                  sx={{
                    mt: 4, width: '40%', py: 1,
                    borderRadius: 6,
                    backgroundColor: '#1b1914',
                    '&:hover': {
                      backgroundColor: '#332a14ff',
                    },
                  }}
                >
                  submit
                </Button>
              </Box>
            </>
          )}

          {/* Alerts */}
          {
            message && (
              <Alert
                severity={message.type === "error" ? "error" : "success"}
                sx={{ mb: 3, borderRadius: 2 }}
              >
                {message.text}
              </Alert>
            )
          }

        </form>
      </Paper>
    </Box >
  );
};

export default SchoolRegister;
